































import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { Tab } from "@/types";
import BasePage from "@/components/BasePage";
import BubbleTabs from "@/components/BubbleTabs";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import MessageGalleryItem from "./MessageGalleryItem.vue";
import MessagePreviewModal from "./MessagePreviewModal.vue";
import { MessageGalleryFilters } from "../types";

export default defineComponent({
  name: "MessageGalleryView",
  components: {
    BasePage,
    MessagePreviewModal,
    BubbleTabs,
    MessageGalleryItem,
    InfiniteScroll,
    PageTitle,
    EmptyContent,
  },
  props: {
    loading: { type: Boolean, default: false },
    enableScroll: { type: Boolean, default: false },
    opponent: { type: Object as PropType<UserPublicData> },
    opponentId: { type: String, required: true },
    messages: { type: Array as PropType<Message[]>, default: () => [] },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, required: true },
  },
  setup(props, { emit }) {
    const { authUser, isCreator } = useAuthUser();
    const tabs: Tab[] = [
      {
        text: $t("All"),
        value: "all",
      },
      {
        text: $t("Unlocked"),
        value: "purchased",
      },
      {
        text: $t("Locked"),
        value: "not_purchased",
      },
      {
        text: $t("Free"),
        value: "free",
      },
    ];

    const activeMessage = ref<Message>();
    const purchasableMessage = ref<Message>();
    const showUnlock = ref(false);
    const activeTab = ref(tabs[0].value);

    const description = computed(() => {
      const firstUser = isCreator.value ? authUser.value : props.opponent;
      const secondUser = isCreator.value ? props.opponent : authUser.value;
      if (!firstUser || !secondUser) return "";
      return firstUser?.screenName + " x " + secondUser?.screenName;
    });

    const handleChangeTab = (value: MessageGalleryFilters) => {
      activeTab.value = value;
      emit("filter", activeTab.value);
    };

    const handleMessageClick = (message: Message) => {
      activeMessage.value = message;
    };

    watch(
      () => props.messages,
      () => {
        if (activeMessage.value) {
          const activeId = activeMessage.value.id;
          activeMessage.value = props.messages.find(message => message.id === activeId);
        }
      }
    );

    return {
      description,
      activeTab,
      activeMessage,
      tabs,
      showUnlock,
      purchasableMessage,
      handleChangeTab,
      handleMessageClick,
    };
  },
});
